module.exports = __webpack_public_path__ + "img/3_151.62b49464.png";